import { Fragment, h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import NoAutoCompleteInput from '../../utils/NoAutoCompleteInput'; /** @jsx h */

const CODE_LENGTH = 4;

const CodePanel = ({
    handleCodeSubmit,
    returnToStart,
    errorMessage,
    unableToRetry
}) => {
    const [enteredCode, setEnteredCode] = useState('');
    const [focused, setFocused] = useState(false);

    const values = enteredCode.split('');
    const input = useRef(null);

    const handleFocus = () => {
        setFocused(true);
    };

    const handleBlur = () => {
        setFocused(false);
    };

    useEffect(() => {
        input.current.focus();
    }, []);

    const handleClick = () => {
        input.current.focus();
    };

    const onSubmit = e => {
        e.preventDefault();

        handleCodeSubmit(enteredCode);
    };

    return (
        <Fragment>
            <h2>Skriv inn kode du får oppgitt fra operatør</h2>

            <div className="wrap code">
                <form onSubmit={onSubmit}>
                    <NoAutoCompleteInput
                        autoFocus
                        name="code"
                        onInput={e => setEnteredCode(e.target.value)}
                        ref={input}
                        maxLength={4}
                        spellCheck="false"
                        className="code-input"
                        pattern="[0-9]{4}"
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        title="Vennligst skriv fire siffer"
                        type="tel"
                        style={{ maxWidth: '100%' }}
                    />
                    {unableToRetry ? (
                        <button
                            type="button"
                            className="codepanel-confirm-button"
                            onClick={() => returnToStart()}
                        >
                            Tilbake
                        </button>
                    ) : (
                        <button className="codepanel-confirm-button">
                            Send
                        </button>
                    )}
                </form>
                {[...Array(CODE_LENGTH)].map((v, index) => {
                    const selected = enteredCode.length === index;
                    const filled =
                        enteredCode.length === CODE_LENGTH &&
                        index === CODE_LENGTH - 1;

                    return (
                        <div
                            className="display"
                            key={index}
                            onClick={handleClick}
                        >
                            {values[index]}
                            {(selected || filled) && focused && (
                                <div className="shadows" />
                            )}
                        </div>
                    );
                })}
            </div>
            <div className="error-message">
                <p>{errorMessage}</p>
            </div>
        </Fragment>
    );
};

export default CodePanel;
